// extracted by mini-css-extract-plugin
export var button = "styles-module--button--4becc";
export var subtitle = "styles-module--subtitle--f0e0f";
export var title = "styles-module--title--868db";
export var wrapper = "styles-module--wrapper--cf746";